import { useParams } from "react-router-dom";
import EditAssignReferralReq from "./EditAssignReferralReq";
import { useGetRefReqByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForReferrals";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";

const EditAssignReferralReqHome = () => {
  let { Id } = useParams();
  const {
    isSuccess,
    isFetching,
    error,
    data: dataById,
    isError,
    isFetched,
  } = useGetRefReqByIdQuery({ Id });

  return (
    <div>
      {(!!isFetching) && "Wait, Loading..."}

      {!!isSuccess && <EditAssignReferralReq referralById={dataById} />}

      <MpgErrorDialog
        open={!!isError}
      />
    </div>
  );
};
export default EditAssignReferralReqHome;
